var map = {
	"./1alB-a'-cha'.jpg": "7843",
	"./1alB-a'-cha'.mp3": "4cc0",
	"./1alB-a'a-za'a.jpg": "d6ee",
	"./1alB-a'a-za'a.mp3": "c6f8",
	"./1alB-a-ya.jpg": "8494",
	"./1alB-a-ya.mp3": "0b0f",
	"./1alB-ah-bgah.jpg": "b458",
	"./1alB-ah-bgah.mp3": "c915",
	"./1alB-b-bex.jpg": "8f56",
	"./1alB-b-bex.mp3": "764a",
	"./1alB-ch-chuhd.jpg": "cf93",
	"./1alB-ch-chuhd.mp3": "6c48",
	"./1alB-d-duh.jpg": "e762",
	"./1alB-d-duh.mp3": "2deb",
	"./1alB-dz-dzul.jpg": "dc7a",
	"./1alB-dz-dzul.mp3": "4c5a",
	"./1alB-e-de.jpg": "2fb2",
	"./1alB-e-de.mp3": "de86",
	"./1alB-g-gah.jpg": "336d",
	"./1alB-g-gah.mp3": "b884",
	"./1alB-i-lni.jpg": "0892",
	"./1alB-i-lni.mp3": "d388",
	"./1alB-j-jid.jpg": "5ae0",
	"./1alB-j-jid.mp3": "9954",
	"./1alB-k-kua.jpg": "b48c",
	"./1alB-k-kua.mp3": "eab2",
	"./1alB-l-lage'.jpg": "7fe8",
	"./1alB-l-lage'.mp3": "8780",
	"./1alB-lh-lhape'.jpg": "cc0a",
	"./1alB-lh-lhape'.mp3": "a883",
	"./1alB-ll-llit.jpg": "0899",
	"./1alB-ll-llit.mp3": "0b55",
	"./1alB-m-dam.jpg": "b582",
	"./1alB-m-dam.mp3": "b7e7",
	"./1alB-n-gu'n.jpg": "98ab",
	"./1alB-n-gu'n.mp3": "a69c",
	"./1alB-nh-bzi'inh.jpg": "0986",
	"./1alB-nh-bzi'inh.mp3": "942d",
	"./1alB-o-ros.jpg": "cce9",
	"./1alB-o-ros.mp3": "f422",
	"./1alB-p-Laxup.jpg": "0be3",
	"./1alB-p-Laxup.mp3": "7120",
	"./1alB-r-ret.jpg": "70c7",
	"./1alB-r-ret.mp3": "770e",
	"./1alB-s-setw.jpg": "4013",
	"./1alB-s-setw.mp3": "255c",
	"./1alB-sh-shnej.jpg": "28a1",
	"./1alB-sh-shnej.mp3": "7187",
	"./1alB-t-tap.jpg": "297c",
	"./1alB-t-tap.mp3": "16a1",
	"./1alB-t-yet.mp3": "fe6c",
	"./1alB-ts-tsupe.jpg": "061c",
	"./1alB-ts-tsupe.mp3": "e47a",
	"./1alB-u-gu.jpg": "c729",
	"./1alB-u-gu.mp3": "7465",
	"./1alB-w-wi.jpg": "888e",
	"./1alB-w-wi.mp3": "c574",
	"./1alB-x-xuge'.jpg": "3e6a",
	"./1alB-x-xuge'.mp3": "4de8",
	"./1alB-x-xup.mp3": "a55a",
	"./1alB-xh-xhile'.jpg": "5951",
	"./1alB-xh-xhile'.mp3": "f3b6",
	"./1alB-y-yag.jpg": "1156",
	"./1alB-y-yag.mp3": "3ece",
	"./1alB-z-zah.jpg": "02de",
	"./1alB-z-zah.mp3": "a194",
	"./1fie-a-Ini.jpg": "8e25",
	"./1fie-a-lni.mp3": "4b64",
	"./1fie-b-debillda'a.jpg": "6c2a",
	"./1fie-b-debillda'a.mp3": "a993",
	"./1fie-c-nes.jpg": "f5b4",
	"./1fie-c-nes.mp3": "1d0c",
	"./1fie-d-calend.jpg": "5940",
	"./1fie-d-calend.mp3": "5565",
	"./1fie-e-yu'udo'.jpg": "4a92",
	"./1fie-e-yu'udo'.mp3": "ab9b",
	"./1fie-f-santw.jpg": "ead9",
	"./1fie-f-santw.mp3": "7429",
	"./1fie-g-gu'unh (1).jpg": "25c5",
	"./1fie-g-gu'unh.mp3": "e7f0",
	"./1fie-h-le'ej.jpg": "c44f",
	"./1fie-h-le'ej.mp3": "aa86",
	"./1fie-h-le'ej.png": "c82c",
	"./1fie-i-musikw.jpg": "c01e",
	"./1fie-i-musikw.mp3": "f890",
	"./1fie-j-bene'se'kwell.jpg": "25b7",
	"./1fie-j-bene'se'kwell.mp3": "f553",
	"./1fie-j-musician.jpg": "80fa",
	"./1fie-k-niswkan.jpg": "3c81",
	"./1fie-k-niswkan.mp3": "4dbd",
	"./1fie-l-yetgu.jpg": "a9e6",
	"./1fie-l-yetgu.mp3": "09b1",
	"./1fie-m-niseye'.jpg": "1cc3",
	"./1fie-m-niseye'.mp3": "cc51",
	"./1fie-n-shkulat.jpg": "ab6f",
	"./1fie-n-shkulat.mp3": "7607",
	"./1fie-o-bene'bi'alla.jpg": "b0d6",
	"./1fie-o-bene'bi'alla.mp3": "eb8a",
	"./1fie-q-dance.jpg": "edf2",
	"./1fie-r-eat.jpg": "f89a",
	"./A.jpg": "8a8e",
	"./A.mp3": "a0db",
	"./B.jpg": "a4f3",
	"./C.jpg": "6fc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";